import { useState } from "react";
import { Tooltip } from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import API from "scripts/api";
import Resources from "scripts/resources";
import Icons from "scripts/icons";

const Component = ({
	address,
	bookmarked: defBookmarked,
	category,
	cover,
	discount,
	id,
	slug,
	title,
	user,
}) => {
	const [bookmarked, setBookmarked] = useState(defBookmarked);

	const bookmark = (id) => {
		API.job
			.bookmark(id)
			.then(({ bookmarked }) => {
				setBookmarked(bookmarked);
			})
			.catch(() => {});
	};

	return (
		<div
			className={`pwa-job-card${Number(discount.raw) > 0 ? " discounted" : ""}`}
		>
			<Link to={`/job/${slug}`}>
				<span
					className="cover"
					style={{ backgroundImage: `url(${cover?.url})` }}
				/>
			</Link>

			<h3 className="title">
				<Link to={`/job/${slug}`}>{title}</Link>
			</h3>

			<span className="category">
				<Link to={`/jobs?category=${category?.slug}`}>
					<img
						src={category?.icon}
						alt={category?.title}
					/>
					{category?.title}
				</Link>
			</span>

			<span className="address">{address}</span>

			{user?.id ? (
				bookmarked ? (
					<Icons.Saved
						className="bookmark gray"
						onClick={() => bookmark(slug)}
					/>
				) : (
					<Icons.Save
						className="bookmark"
						onClick={() => bookmark(slug)}
					/>
				)
			) : (
				<Link to="/auth/status">
					<Tooltip title={Resources.saveCondition}>
						<Icons.Save className="bookmark" />
					</Tooltip>
				</Link>
			)}

			{Number(discount?.raw) > 0 && (
				<span className="discount">
					{discount?.formatted} {Resources.discountPercent}
				</span>
			)}
		</div>
	);
};

export default connect((state) => {
	return {
		user: state.user,
	};
})(Component);
